import { render } from "./OurService.vue?vue&type=template&id=cb95e4f2"
import script from "./OurService.vue?vue&type=script&lang=js"
export * from "./OurService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__